export default function (value) {
  this.el.disabled = Boolean(value)
}
